'use strict';

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * utilities
 *
 * remove polyfill for ie
 * custom event polyfill for ie
 * extend
 * handleize
 * namespace
 * ready
 * dom event
 * add event
 * remove event
 * get url parameter
 * debounce
 * media query
 * ajax
 * replace
 * is visible
 * has class
 * add class
 * remove class
 * transition
 * get hidden height
 * window resize
 * hide
 * show
 * get hidden height
 * slide up
 * slide down
 * get sized image url
 * remove protocol
 * format price
 * format price display
 * serialize
 * object to query string
 * is object
 * is object empty
 * get query string
 * encode
 * scroll to
 * index
 * waypoint
 * remap size values
 * array to lower
 */

/**
 * remove polyfill for ie
 */
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }

    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
/**
 * custom event polyfill for ie
 */


(function () {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();
/**
 * ready
 * equivalent of jQuery's $(document).ready();
 * @param  {Function} fn function to run when the document is ready
 * @return {Function} Rturns passed function when document is ready.
 */


_.ready = function (fn) {
  if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};
/**
 * extend
 * extends a js object
 * @param  {Object} config
 * @param  {Object} obj
 * @return {Object}
 */


_.extend = function (config, obj) {
  obj = obj || {};
  Object.keys(config).forEach(function (key) {
    if (obj[key] === undefined) {
      obj[key] = config[key];
    } else {
      if (obj[key] && _.isObject(obj[key])) {
        Object.keys(config[key]).forEach(function (childKey) {
          if (obj[key][childKey] === undefined) {
            obj[key][childKey] = config[key][childKey];
          }
        });
      }
    }
  });
  return obj;
};
/**
 * handleize
 * converts a string to a handle
 */
_.handleize = function(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
}

/**
 * namespace
 * @param  {Object} obj
 * @param  {String} Name
 * @return {Object}
 */


_.namespace = function (obj, name) {
  obj = obj || {};
  obj = JSON.parse(JSON.stringify(obj));
  var objNode, namedVar;

  if (obj) {
    if (obj && _.isObject(obj)) {
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          if (_typeof(obj[key]) !== 'object') {
            objNode = obj[key].toString();
            namedVar = name + objNode.charAt(0).toUpperCase() + objNode.slice(1);
            obj[key] = namedVar;
          } else if (Array.isArray(obj[key])) {
            obj[key].forEach(function (id, idx, arr) {
              objNode = name + id.charAt(0).toUpperCase() + id.slice(1);
              arr[idx] = objNode;
            });
          }
        }
      });
    } else {
      console.warn('obj is not defined, or is not an object');
    }
  }

  return obj;
};
/**
 * Dom Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 * @param {boolean} - applyEvent - Dictates whether to addEventListener or removeEventListener
 */


_.domEvent = function (opts, applyE) {
  var c = opts,
      eApply = applyE !== undefined ? applyE : true,
      $id,
      $class,
      isString,
      hasIds,
      hasEvents,
      $trigger,
      i,
      idArr,
      eventArr;
  /**
   * init
   * @return {function} Checks if c.id, c.fn, and c.event are defined. If not add event is skipped. This also maps the variables for $id and domClass
   */

  function init() {
    if (c.id) {
      // Is c.id set?
      if (c.fn || c.event) {
        // If c.fn and c.event are set then execute functions.
        checkForArray();

        if (hasIds) {
          idArr = c.id.split(',');

          for (i = 0; i < idArr.length; i++) {
            c.id = idArr[i];
            bindEvents();
          }
        } else {
          bindEvents();
        }
      } else {
        if (c.fn === null) {
          // Check if c.fn is set, if not warn the developer.
          console.warn('No function defined.');
        }

        if (c.event === null) {
          // Check if c.event is set, if not warn the developer.
          console.warn('No event defined.');
        }
      }
    } else {
      // if c.id is not set, then warn the developer.
      console.warn('No ID defined.');
    }
  }
  /**
   * check for array
   */


  function checkForArray() {
    isString = typeof c.id === 'string' ? true : false;

    if (isString) {
      hasIds = _.isDelimitedArray(c.id);
    }

    hasEvents = _.isDelimitedArray(c.event);
  }
  /**
   * bind events
   * @type {Function}
   */


  function bindEvents() {
    mapVars(); // Map vas called inside c.fn and c.event check to avoid unnecessary DOM search.

    if (c.className) {
      bindLoop(); // If a class value was set, bind the event to dom elements within a parent id.
    } else {
      bindSingle(); // If only an id was set and no className, then bind the event to a single id.
    }
  }
  /**
   * map vars
   * @return {function} Sets domId variable and if c.className exists, sets domClass value.
   */


  function mapVars() {
    if (isString) {
      $id = document.getElementById(c.id);
    } else {
      $id = c.id;
    }

    if ($id) {
      if (c.className === null) {
        $class = null;
      } else {
        $class = $id.querySelectorAll('.' + c.className);
      }
    } else {
      if (isString) {
        console.warn('Could not find id ' + c.id);
      } else {
        console.warn('Could not find element.');
      }
    }
  }
  /**
   * bind loop
   * @return {function} Bind events to dom elements within the defined c.id dom element.
   */


  function bindLoop() {
    if ($class) {
      for (i = 0; i < $class.length; i++) {
        $trigger = $class[i];

        if ($trigger) {
          if (eApply) {
            if (hasEvents) {
              eventArr = c.event.split(',');

              for (i = 0; i < eventArr.length; i++) {
                $trigger.addEventListener(eventArr[i], c.fn, null);
              }
            } else {
              $trigger.addEventListener(c.event, c.fn, null);
            }
          } else {
            $trigger.removeEventListener(c.event, c.fn, null);
          }
        }
      }
    }
  }
  /**
   * bind single
   * @return {function} Add event listener to a single dom element based on id.
   */


  function bindSingle() {
    if ($id) {
      if (eApply) {
        if (hasEvents) {
          eventArr = c.event.split(',');

          for (i = 0; i < eventArr.length; i++) {
            $id.addEventListener(eventArr[i], c.fn, null);
          }
        } else {
          $id.addEventListener(c.event, c.fn, null);
        }
      } else {
        $id.removeEventListener(c.event, c.fn, null);
      }
    }
  }

  return init();
};
/**
 * Add Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 */


_.addEvent = function (opts) {
  if (opts === undefined) {
    console.warn('_.addEvent requires a config object.');
  } else {
    _.domEvent(opts, true);
  }
};
/**
 * Remove Event
 * @type {function}
 * @param {object | string} obj.id -  Text string for the id of the dom element bind events. If used in conjunction with className the ID should repesent the parent object's id.
 * @param {object | string} obj.className - Text string for the class name of the dom element to bind events. Must be used in conjunction with an ID to reduce DOM traversal.
 * @param {object | string} object.event - Event which triggers the function.
 * @param {object.function} object.fn - Function to bind to each element.
 */


_.removeEvent = function (opts) {
  if (opts === undefined) {
    console.warn('_.removeEvent requires a config object.');
  } else {
    _.domEvent(opts, false);
  }
};
/**
 * trigger event
 * @param  {object} el - Element that event is being triggered on. Must pass selected dom element, not just a string.
 * @param  {string} eventName - Name of custom event that needs to be trigger.
 * @param  {boolean} bubbles - A Boolean indicating whether the event bubbles up through the DOM or not. Default: true
 * @param  {boolean} cancelable - A Boolean indicating whether the event is cancelable. Default: true
 * @return {function} - Dispatches the custom event that's bound to the element.
 */


_.trigger = function (el, eventName, bubbles, cancelable) {
  if (el === undefined || eventName === undefined) return false;
  if (bubbles === undefined) bubbles = true;
  if (cancelable === undefined) cancelable = true;
  var event = new CustomEvent(eventName, {
    detail: {
      message: el,
      time: new Date()
    },
    bubbles: bubbles,
    cancelable: cancelable
  });
  el.dispatchEvent(event);
};
/**
 * get url parameter
 * @param {string} sParam - parameter name
 */


_.getUrlParameter = function (sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};
/**
 * debounce
 * @param {fn} The function that needs to be debounce
 * @param {int} Miliseconds for how often to execute the function
 * @param {boolean} Execute immediately or after function is complete
 */


_.debounce = function (func, threshold, execAsap) {
  var timeout;
  return function debounced() {
    var obj = this,
        args = arguments;

    function delayed() {
      if (!execAsap) func.apply(obj, args);
      timeout = null;
    }

    if (timeout) clearTimeout(timeout);else if (execAsap) func.apply(obj, args);
    timeout = setTimeout(delayed, threshold || 100);
  };
};
/**
 * media query
 * @param {object} argument object
 * @param {string} object.view - the targetted screen size to execute the function
 * @param {fn} oject.callback - function to execute
 * @param {object} oject.views - array of available views that can be targetted
 */


_.mq = function (opts) {
  var config = {
    callback: null,
    view: null,
    views: {
      smallest_phone: '(max-width:374px)',
      small_phone: '(max-width:640px)',
      phone: '(max-width:767px)',
      mobile: '(max-width:1024px)',
      pocket: '(max-width:1007px)',
      phone_to_desktop: '(min-width:563px)',
      tablet: '(min-width:768px)',
      tablet_only: '(min-width:768px) and (max-width:1024px)',
      tablet_portrait: '(min-width:768px) and (max-width:979px)',
      tablet_landscape: '(min-width:980px) and (max-width:1024px)',
      lap_and_up: '(min-width:1008px)',
      desktop: '(min-width:1025px)',
      desktop_to_large: '(min-width:1025px) and (max-width:1280px)',
      desktop_large: '(min-width:1281px)',
      desktop_large_to_huge: '(min-width:1281px) and (max-width:1400px)',
      desktop_huge: '(min-width:1401px)'
    }
  },
      c = _.extend(config, opts),
      currentView = null,
      mq = {
    init: function init() {
      if (c.view) {
        Object.keys(c.views).forEach(function (key) {
          if (key === c.view) {
            currentView = c.views[key];
          }
        });
        var query = window.matchMedia(currentView);

        if (query.matches === true) {
          if (typeof c.callback === 'function') {
            c.callback();
          }
        }
      }
    }
  };

  return mq.init();
};
/**
 * ajax
 * @param  {Object} opts
 * @return {_.ajax~init}
 */


_.ajax = function (opts) {
  var config = {
    contentType: null,
    data: '',
    dataObject: {},
    headers: {},
    type: null,
    url: '',
    success: function success(resp) {
      console.log(resp);
    },
    error: function error(resp) {
      console.warn(resp);
    }
  },
      c = _.extend(config, opts),
      xhr;
  /**
   * init
   */


  function init() {
    xhr = new XMLHttpRequest();
    xhr.open(c.type, c.url, true);
    setHeaders(xhr);
    xhr.onload = onLoadHandler;
    xhr.onError = errorHandler;

    if (c.data) {
      xhr.send(_.objectToQueryString(c.data));
    } else {
      if (c.dataObject) {
        xhr.send(_.objectToQueryString(c.dataObject));
      } else {
        console.warn('data is not defined.');
      }
    }
  }
  /**
   * set headers
   * @param {Object} xhr
   */


  function setHeaders(xhr) {
    var defaultContentType = 'application/x-www-form-urlencoded; charset=UTF-8',
        contentType = c.contentType ? c.contentType : defaultContentType,
        headers = c.headers;

    if (!_.isObjectEmpty(headers)) {
      if (!hasContentType(headers)) {
        headers['Content-Type'] = defaultContentType;
      }

      Object.keys(headers).forEach(function (name) {
        xhr.setRequestHeader(name, headers[name]);
      });
    } else {
      xhr.setRequestHeader('Content-Type', contentType);
    }
  }
  /**
   * has content type
   * @param  {Object}  headers
   * @return {Boolean}
   */


  function hasContentType(headers) {
    return Object.keys(headers).some(function (name) {
      return name.toLowerCase() === 'content-type';
    });
  }
  /**
   * on load handler
   * @callback
   */


  function onLoadHandler() {
    var resp = xhr.responseText; // check if response text is an object.

    if (_typeof(resp) !== 'object') {
      try {
        resp = JSON.parse(resp);
      } catch (e) {}
    } // check xhr status


    if (xhr.status >= 200 && xhr.status < 400) {
      // check if response has a status code
      if (resp.status) {
        // check status code for success
        if (resp.status >= 200 && resp.status < 400) {
          c.success(resp);
        } else {
          c.error(resp);
        }
      } else {
        c.success(resp);
      }
    } else {
      c.error(resp);
    }
  }
  /**
   * on load handler
   * @callback
   */


  function errorHandler() {
    c.error(xhr.responseText);
  }

  return init();
};
/**
 * replace
 * @param  {string} string
 * @param  {string} needle   searched value
 * @param  {string} newValue new value you wish to replace the needle with
 * @return {string}
 */


_.replace = function (string, needle, newValue) {
  var newString; // if string contains needle, return new value

  if (string.indexOf(needle) !== -1) {
    newString = string.replace(needle, newValue);
  } // else return string as-is if needle could not be found
  else {
      newString = string;
    }

  return newString;
};
/**
 * is visible
 * @param  {element} el
 * @return {boolean}
 */


_.isVisible = function (el) {
  return el.offsetParent !== null;
};
/**
 * has class
 * @param  {element}  el
 * @param  {string}  className
 * @return {boolean}
 */


_.hasClass = function (el, className) {
  if (el.classList) {
    return el.classList.contains(className);
  } else {
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  }
};
/**
 * add class
 * @param {string} el
 * @param {string} className
 */


_.addClass = function (el, className) {
  if (!_.hasClass(el, className)) {
    if (el.classList) {
      el.classList.add(className);
    } else {
      el.className += ' ' + className;
    }
  }
};
/**
 * remove class
 * @param {element} el
 * @param {string} className
 */


_.removeClass = function (el, className) {
  if (_.hasClass(el, className)) {
    if (el.classList) {
      el.classList.remove(className);
    } else {
      el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  }
};
/**
 * transition
 * fires a function before and after a timeout
 * @param {object} opts
 */


_.transition = function (opts) {
  if (opts.before === undefined) opts.before = null;
  if (opts.after === undefined) opts.before = null;
  if (opts.time === undefined) opts.time = 400;

  if (typeof opts.before === 'function') {
    opts.before();
  }

  if (typeof opts.after === 'function') {
    setTimeout(opts.after, opts.time);
  }
};
/**
 * get hidden height
 * @param {element}
 * @return {int}
 */


_.getHiddenStyles = function (el) {
  var $clone = el.cloneNode(true),
      $parent = el.parentNode,
      posVal = window.getComputedStyle($parent).position,
      body = document.body,
      docEl = document.documentElement,
      scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop,
      clientTop = docEl.clientTop || body.clientTop || 0,
      $cloneInDom = null,
      cloneHeight = null,
      cloneOffsetTop,
      clonePaddingTop = null,
      clonePaddingBottom = null,
      cloneRect;

  if (posVal === 'static') {
    $parent.style.position = 'relative';
  } // Add attribute to track element for deletion;


  $clone.setAttribute('data-clone', 'true'); // Append the new cloen to to the parent.

  $parent.appendChild($clone); // Select that new clone

  $cloneInDom = $parent.querySelector('[data-clone="true"]'); // Display the clone with visibility hidden so that size can be retrieved.

  $cloneInDom.style.height = 'auto';
  $cloneInDom.style.display = 'block';
  $cloneInDom.style.visibility = 'hidden';
  $cloneInDom.style.position = 'absolute'; // Get Height

  cloneHeight = $cloneInDom.offsetHeight; // Get Padding Top

  clonePaddingTop = window.getComputedStyle($cloneInDom).paddingTop; // Get Padding Bottom;

  clonePaddingBottom = window.getComputedStyle($cloneInDom).paddingBottom; // Get Rectangle

  cloneRect = $cloneInDom.getBoundingClientRect(); // Get OffsetTop

  cloneOffsetTop = Math.round(cloneRect.top + scrollTop - clientTop); // Delete the clone

  $cloneInDom.remove(); // Remove the position value added to the parent when its static.

  if (posVal === 'static') {
    $parent.style.position = '';
  } // Return values


  return {
    elHeight: cloneHeight,
    elOffsetTop: cloneOffsetTop,
    elPaddingTop: clonePaddingTop,
    elPaddingBottom: clonePaddingBottom
  };
};
/**
 * window resize
 * Run functions on window resize.
 * @param {function} function to call on window resize
 * @param {int} how often in miliseconds to fire the debounced function
 * @param {boolean} sets whether to execute the function as soon as possible or not.
 */


_.windowResize = function (fn, threshold, execAsap) {
  if (fn === undefined) fn = null;
  if (threshold === undefined) threshold = 100;
  if (execAsap === undefined) execAsap = false;

  if (fn) {
    window.addEventListener('resize', _.debounce(fn, threshold, execAsap));
  } else {
    console.warn('No function defined.');
  }
};
/**
 * hide
 * @param {Object} obj - dom element to hide
 */


_.hide = function (obj) {
  if (obj && obj.style.display !== 'none') {
    obj.style.display = 'none';
  }
};
/**
 * show
 */


_.show = function (obj) {
  if (obj && obj.style.display === 'none') {
    obj.style.display = 'block';
  }
};
/**
 * slide up
 * @param {element} DOM Element
 * @param {int} Animation timer
 */


_.slideUp = function (el) {
  if (el === undefined) el = null;

  if (el) {
    el.style.height = el.offsetHeight + 'px';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  }
};
/**
 * slide down
 * @param {element} DOM Element
 * @param {int} Animation timer
 */


_.slideDown = function (el) {
  if (el === undefined) el = null;

  if (el) {
    var hiddenStyles = _.getHiddenStyles(el);

    var menuHeight = hiddenStyles.elHeight;
    var padTop = hiddenStyles.elPaddingTop;
    var padBottom = hiddenStyles.elPaddingBottom;
    el.style.display = 'block';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.height = 0;
    setTimeout(function () {
      el.style.height = menuHeight + 'px';
      el.style.paddingTop = padTop;
      el.style.paddingBottom = padBottom;
    }, 1);
  }
};
/**
 * get sized image url
 * @param  {string} imgUrl
 * @param  {string} size   image width, e.x. '250x'
 * @return {string}        resized image url
 */


_.getSizedImageUrl = function (imgUrl, size) {
  var i, n, r;
  if (!imgUrl) return '//cdn.searchspring.net/ajax_search/img/missing-image-75x75.gif';
  if (!size) return imgUrl;
  if (size === 'master') return _.removeProtocol(imgUrl);
  n = imgUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (n !== null) {
    r = imgUrl.split(n[0]);
    i = n[0];
    return _.removeProtocol(r[0] + '_' + size + i);
  }
};
/**
 * remove protocol
 * @param  {string} url
 * @return {string}
 */


_.removeProtocol = function (url) {
  return url.replace(/http(s)?:/, '');
};
/**
 * format price
 * @param  {number} price e.x. "1200"
 * @return {string}       e.x. "12.00"
 */


_.formatPrice = function (price) {
  return (price / 100).toFixed(2);
};
/**
 * format price display
 * @param  {number} price e.x. "1200"
 * @return {string}       e.x. "$12"
 */


_.formatPriceDisplay = function (price) {
  return '$' + _.formatPrice(price).replace(/\.00$/, '');
};
/**
 * serialize
 * @param form object
 */


_.serialize = function (form, type) {
  if (!form || form.nodeName !== 'FORM') {
    return;
  }

  var isDataObject = type ? true : false;
  var i,
      j,
      q = [],
      o = {};

  for (i = form.elements.length - 1; i >= 0; i = i - 1) {
    if (form.elements[i].name === '') {
      continue;
    }

    switch (form.elements[i].nodeName) {
      case 'INPUT':
        switch (form.elements[i].type) {
          case 'text':
          case 'hidden':
          case 'password':
          case 'button':
          case 'reset':
          case 'submit':
          case 'color':
          case 'date':
          case 'datetime-local':
          case 'email':
          case 'month':
          case 'number':
          case 'range':
          case 'search':
          case 'tel':
          case 'time':
          case 'url':
          case 'week':
            q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
            o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
            break;

          case 'checkbox':
          case 'radio':
            if (form.elements[i].checked) {
              q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
              o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
            }

            break;

          case 'file':
            break;
        }

        break;

      case 'TEXTAREA':
        q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
        o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
        break;

      case 'SELECT':
        switch (form.elements[i].type) {
          case 'select-one':
            q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
            o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
            break;

          case 'select-multiple':
            for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
              if (form.elements[i].options[j].selected) {
                q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].options[j].value));
                o[form.elements[i].name] = encodeURIComponent(form.elements[i].options[j].value);
              }
            }

            break;
        }

        break;

      case 'BUTTON':
        switch (form.elements[i].type) {
          case 'reset':
          case 'submit':
          case 'button':
            q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
            o[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
            break;
        }

        break;
    }
  }

  if (isDataObject) {
    return o;
  } else {
    return q.join('&');
  }
};
/**
 * object to query string
 * if no object is provided, function will return original data
 * @param  {Object} data
 * @return {string}
 */


_.objectToQueryString = function (data) {
  return _.isObject(data) ? _.getQueryString(data) : data;
};
/**
 * is object
 * @param  {*}       data any type
 * @return {boolean}
 */


_.isObject = function (data) {
  return Object.prototype.toString.call(data) === '[object Object]';
};
/**
 * is delineated array
 * @param  {*}       data any type
 * @return {boolean}
 */


_.isDelimitedArray = function (str, delimiter) {
  if (!str) {
    console.warn('No string defined');
    return false;
  }

  if (!delimiter) {
    delimiter = ',';
  }

  return str.indexOf(delimiter) !== -1 ? true : false;
};
/**
 * is object empty
 * @param  {Object}  obj
 * @return {boolean}
 */


_.isObjectEmpty = function (obj) {
  return _.isObject(obj) && Object.keys(obj).length === 0;
};
/**
 * get query string
 * @param  {Object} object
 * @return {string}
 */


_.getQueryString = function (object) {
  return Object.keys(object).reduce(function (acc, item) {
    var prefix = !acc ? '' : acc + '&';
    return prefix + _.encode(item) + '=' + _.encode(object[item]);
  }, '');
};
/**
 * encode
 * @param  {string} value
 * @return {string}
 */


_.encode = function (value) {
  return encodeURIComponent(value);
};
/**
 * Smooth scroll
 * @param  options [target: where you want the link to scroll to, link: the link you want to target with an ID ]
 */


_.scrollTo = function (opts) {
  var config = {
    callback: null,
    className: null,
    exec_now: false,
    id: null,
    offset: 0,
    target: null,
    timer: 500
  },
      c = _.extend(config, opts);

  function init() {
    if (c.exec_now) {
      scroll();
    } else {
      if (c.id) {
        addEvents();
      } else {
        console.warn('no id defined');
      }
    }
  }

  function addEvents() {
    _.addEvent({
      id: c.id,
      className: c.className,
      event: 'click',
      fn: scroll
    });
  }

  function scroll(e) {
    var start = window.pageYOffset,
        target = c.target ? c.target : this.getAttribute('href').replace('#', ''),
        distance,
        duration,
        timeStart,
        timeElapsed;
    target = typeof target === 'string' ? document.getElementById(target) : target;

    if (target) {
      if (e) {
        e.preventDefault();
      }
    } else {
      return false;
    }

    distance = c.offset + target.getBoundingClientRect().top;
    duration = typeof c.timer === 'function' ? c.timer(distance) : c.timer;
    requestAnimationFrame(function (time) {
      timeStart = time;
      loop(time);
    });

    function loop(time) {
      timeElapsed = time - timeStart;
      window.scrollTo(0, easeInOutQuad(timeElapsed, start, distance, duration));

      if (timeElapsed < duration) {
        requestAnimationFrame(loop);
      } else {
        end();
      }
    }

    function end() {
      window.scrollTo(0, start + distance);

      if (typeof c.callback === 'function') {
        c.callback();
      }
    }
  } // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/


  function easeInOutQuad(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  return init();
};
/**
 * is parent
 * @param  {Node} elem
 * @param  {String} selector
 * @return {Node}
 */


_.parents = function (elem, selector) {
  var parents = [];
  var firstChar;

  if (selector) {
    firstChar = selector.charAt(0);
  } // Get matches


  for (; elem && elem !== document; elem = elem.parentNode) {
    if (selector) {
      // If selector is a class
      if (firstChar === '.') {
        if (elem.classList.contains(selector.substr(1))) {
          parents.push(elem);
        }
      } // If selector is an ID


      if (firstChar === '#') {
        if (elem.id === selector.substr(1)) {
          parents.push(elem);
        }
      } // If selector is a data attribute


      if (firstChar === '[') {
        if (elem.hasAttribute(selector.substr(1, selector.length - 1))) {
          parents.push(elem);
        }
      } // If selector is a tag


      if (elem.tagName.toLowerCase() === selector) {
        parents.push(elem);
      }
    } else {
      parents.push(elem);
    }
  } // Return parents if any exist


  if (parents.length === 0) {
    return null;
  } else {
    return parents;
  }
};
/**
 * index
 * @param  {Element} node
 * @return {Number}
 */


_.index = function (node) {
  var c = node.parentNode.children,
      i = 0;

  for (; i < c.length; i++) {
    if (c[i] === node) return i;
  }
};
/**
 * waypoint
 * @param  {Object} opts
 * @return {_.waypoint~init}
 */


_.waypoint = function (opts) {
  var config = {
    el: null,
    in: null,
    out: null,
    offset: null
  },
      c = _.extend(config, opts);
  /**
   * init
   */


  function init() {
    addEvents();
    checkWindowPosition();
  }
  /**
   * add events
   */


  function addEvents() {
    // scroll
    window.addEventListener('scroll', checkWindowPosition, false); // resize

    _.windowResize(checkWindowPosition, 400);
  }
  /**
   * check window position
   */


  function checkWindowPosition() {
    var windowPos = window.pageYOffset || document.documentElement.scrollTop,
        elOffset = c.el.offsetTop,
        isPastEl; // offset

    if (c.offset) {
      elOffset -= c.offset;
    }

    isPastEl = windowPos > elOffset;

    if (isPastEl) {
      if (typeof c.in === 'function') c.in();
    } else {
      if (typeof c.out === 'function') c.out();
    }
  }

  return init();
};
/**
 * remap size values
 * @type {Function}
 * @return {String}
 * @desc This is used to remap short hand size values to full words
 */


_.remapSizeValues = function (val) {
  var label;

  if (val) {
    val = val.toLowerCase();
  }

  switch (val) {
    case 'xs':
      label = 'extra small';
      break;

    case 's':
      label = 'small';
      break;

    case 'm':
      label = 'medium';
      break;

    case 'l':
      label = 'large';
      break;

    case 'xl':
      label = 'extra large';
      break;

    case 'xxl':
      label = '2x Large';
      break;

    case '2xl':
      label = '2x Large';
      break;

    case 'xxxl':
      label = '3x Large';
      break;

    case '3xl':
      label = '3x Large';
      break;

    default:
      label = val;
      break;
  }

  return label;
};
/**
 * array to lower
 */


_.arrayToLower = function (r) {
  var c, i;

  if (Array.isArray(r)) {
    c = r.length;

    for (i = 0; i < c; i++) {
      r[i] = r[i].toLowerCase();
    }
  } else {
    console.warn('argument not an array.');
    console.warn(r);
    return false;
  }

  return r;
};
/**
 * reduce array
 */


_.reduceArray = function (r) {
  var c,
      i,
      n = [],
      o;

  if (Array.isArray(r)) {
    c = r.length;

    for (i = 0; i < c; i++) {
      o = r[i];

      if (n.indexOf(o) === -1) {
        n.push(o);
      }
    }
  } else {
    console.warn('argument not an array.');
    console.warn(r);
    return false;
  }

  return n;
};
/**
 * format money
 */


_.formatMoney = function (cents, format, currency) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  currency = currency || '$';

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (format) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_with_currency':
      value = currency + formatWithDelimiters(cents, 2);
      break;

    case 'amount_with_currency_without_trailing_zeros':
      value = currency + formatWithDelimiters(cents, 2);

      if (value.indexOf('.00') !== -1) {
        value = value.replace('.00', '');
      }

      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return value;
};
/**
 * loadJSONP( url, hollaback [, context] ) -> Null
 * - url (String): URL to data resource.
 * - hollaback (Function): Function to call when data is successfully loaded,
 *   it receives one argument: the data.
 * - context (Object): Context to invoke the hollaback function in.
**/


_.loadJSONP = function loadJSONP(window, document, undefined) {
  var uuid = 0,
      head = document.head || document.getElementsByTagName('head')[0],
      main_script = document.createElement('script');
  main_script.type = 'text/javascript';
  return function (url, callback, context) {
    var name, script; // INIT

    name = '__jsonp_' + uuid++;

    if (url.match(/\?/)) {
      url += '&callback=' + name;
    } else {
      url += '?callback=' + name;
    } // Create script


    script = main_script.cloneNode();
    script.src = url; // Setup handler

    window[name] = function (data) {
      callback.call(context || window, data);
      head.removeChild(script);
      script = null;
      delete window[name];
    }; // Load JSON


    head.appendChild(script);
  };
}(window, document);
/**
 * click outside
 * @param  {Object} opts
 * @return {_.clickOutside~init}
 */


_.clickOutside = function (opts) {
  var config = {
    callback: null,
    condition: null,
    exclude_selectors: '',
    selector: ''
  },
      c = _.extend(config, opts),
      // cached globals
  excludedElements = [];
  /**
   * init
   */


  function init() {
    addEvents();
  }
  /**
   * setup excluded
   */


  function setupExcluded() {
    excludedElements = [];
    var excludedSelectors = []; // if there are no excluded selectors, exit function

    if (!c.exclude_selectors) return; // if there's a comma, i.e. multiple selectors, create array from list
    // else push the single item to the array

    if (c.exclude_selectors.indexOf(',') !== -1) {
      excludedSelectors = c.exclude_selectors.split(',');
    } else {
      excludedSelectors.push(c.exclude_selectors);
    } // query selectors and push them to array


    excludedSelectors.forEach(addElementToExcludedArray);
  }
  /**
   * add element to excluded array
   * @callback
   * @param {String} selector
   * @param {Number} i
   * @param {Array}  arr
   */


  function addElementToExcludedArray(selector, i, arr) {
    var el = document.querySelectorAll(selector),
        elCount = el.length,
        children,
        childCount,
        itr,
        childItr;

    if (el) {
      for (itr = 0; itr < elCount; itr++) {
        excludedElements.push(el[itr]);
        children = el.children;
        childCount = children ? children.length : null;

        if (childCount) {
          for (childItr = 0; childItr < childCount; childItr++) {
            excludedElements.push(children[childItr]);
          }
        }
      }
    }
  }
  /**
   * is excluded element
   * @callback
   * @param  {Element} el
   * @param  {Number}  i
   * @param  {Array}   arr
   * @return {Boolean}
   */


  function isExcludedElement(el, i, arr) {
    return el === this;
  }
  /**
   * add events
   */


  function addEvents() {
    // document click
    _.addEvent({
      id: document,
      event: 'click',
      fn: onDocumentClick
    });
  }
  /**
   * on document click
   * @param {Object} e event
   */


  function onDocumentClick(e) {
    setupExcluded();
    var isExElement = excludedElements.some(isExcludedElement, e.target);
    var isConditionFn = typeof c.condition === 'function',
        hasMetConditions = isExElement ? isConditionFn && !isExElement : isConditionFn && c.condition(),
        hasClickedOutside; // if conditions have not been met, exit function

    if (!hasMetConditions) return; // traverse up dom to see if user clicked within selector

    hasClickedOutside = !_.parents(e.target, c.selector); // if clicked outside, fire callback

    if (typeof c.callback === 'function' && hasClickedOutside) c.callback();
  }
  /**
   * return
   * @type {Object}
   */


  return {
    init: init()
  };
};
/**
 * set cookie
 * @param  {String} cName name of the cookie
 * @param  {String} value  value of the cookie
 * @param  {Number} exdays number of days to set the cookie
 * @return {Function}      sets cookie
 */


SDG.setCookie = function (cName, value, exdays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  var cValue = encodeURI(value) + (exdays === null ? '' : "; expires=".concat(exdate.toUTCString()));
  document.cookie = "".concat(cName, " = ").concat(cValue, "; path=/");
};
/**
 * get cookie
 * @param  {String} cName name of the cookie
 * @return {String}        value of the cookie
 */


SDG.getCookie = function (cName) {
  var i;
  var x;
  var y;
  var ARRcookies = document.cookie.split(';');

  for (i = 0; i < ARRcookies.length; i += 1) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
    x = x.replace(/^\s+|\s+$/g, '');

    if (x === cName) {
      return decodeURI(y);
    }
  }

  return false;
};
/**
 * delete cookie
 * @param {string} cName name of the cookie
 */


SDG.deleteCookie = function (cName) {
  document.cookie = "".concat(cName, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
};
/**
 * Get Current Product Handle
 */


function getProductHandle() {
  var url = window.location.href;

  if (url.includes("/products/")) {
    var parts = url.split("/products/");
    var productHandle = parts[parts.length - 1];

    if (productHandle.includes("?")) {
      var newParts = productHandle.split("?");
      productHandle = newParts[0];
      return productHandle;
    } else {
      return productHandle;
    }
  }
}
